<template>
  <div :class="$style.container" v-if="hasPendingTasks">
    <overlay v-show="overlay" />
    <svg
      width="80px"
      height="60px"
      viewBox="0 0 187.3 93.7"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        :class="$style.infinityOutline"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
      />
      <path
        :class="$style.infinityBg"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
      />
    </svg>
    <span> loading... </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Overlay from '@/components/Overlay'

export default {
  name: 'infinite-loader',

  components: { Overlay },

  computed: mapGetters(['hasPendingTasks']),

  props: {
    overlay: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" module>
$len: 300px;
$time: 3000ms;

.container {
  z-index: 1000;
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  color: #fff;

  svg,
  span {
    z-index: 999;
  }

  span {
    text-transform: uppercase;
    line-height: 1.33;
    letter-spacing: 2px;
  }
}

.infinityOutline {
  fill: transparent;
  stroke-width: 4;
  stroke: #fff;
  stroke-dasharray: $len * 0.01, $len;
  stroke-dashoffset: 0;
  animation: anim $time linear infinite !important;
}

.infinityBg {
  fill: transparent;
  stroke-width: 4;
  stroke: #fff;
  opacity: 0.2;
}

@keyframes anim {
  12.5% {
    stroke-dasharray: $len * 0.14, $len;
    stroke-dashoffset: -$len * 0.11;
  }
  43.75% {
    stroke-dasharray: $len * 0.35, $len;
    stroke-dashoffset: -$len * 0.35;
  }
  100% {
    stroke-dasharray: $len * 0.01, $len;
    stroke-dashoffset: -$len * 0.99;
  }
}
</style>
